import {Doughnut} from "react-chartjs-2";
import React from "react";
import {colors, reduceStats} from "./utils";

function ContractedProducts({data, filters, setFilters, isCurrent, postFilters}) {
    const [reduced, index] = reduceStats(data, "contract");

    const labels = ["Contracted", "Non Contracted"]
    const datasets = [];

    index.slice(isCurrent ? 0 : 1, isCurrent ? 1 : 2).forEach((index, _in) =>  {
        datasets.push({
            label: `In ${index}`,
            backgroundColor: colors,
            data: labels.map(x => (reduced[x === "Contracted"] || {})[index] || 0),
        })
    })

    return <Doughnut id={"contract-prod"} width={"100%"} className={"p-2"}
                     data={{
                         labels: labels,
                         datasets: datasets
                     }}
                     options={{
                         responsive: true,
                         maintainAspectRatio: false,
                         aspectRatio: 1,
                         onClick(event, elements, chart) {
                             if (elements.length && elements[0].element) {
                                 if (filters?.contract === (elements[0].index === 0)) {
                                     let d = {...filters};
                                     delete d.contract;
                                     setFilters(d);
                                 } else {
                                     setFilters({...filters, contract: elements[0].index === 0})
                                 }
                             }
                         },
                         plugins: {
                             tooltip: {
                                 callbacks: {
                                     label(tooltipItem) {
                                         return `${tooltipItem.dataset.label} : $${tooltipItem.formattedValue}`
                                     }
                                 }
                             }
                         }
                     }}
    />
}

export default ContractedProducts;